'use client';

import { useTranslations } from 'next-intl';
import { SettingsSection } from '../../settings/SettingsSection';
import {
  CloudInventoryAttachSection,
  type CloudInventoryAttachSectionProps,
} from './CloudInventoryAttachSection';

export type CloudAccountsSettingsSectionProps =
  CloudInventoryAttachSectionProps;

export function CloudAccountsSettingsSection(
  props: CloudAccountsSettingsSectionProps,
) {
  const t = useTranslations(
    'designSystem.networkSettings.externalInventory.cloudAccounts',
  );

  return (
    <SettingsSection title={t('title')} description={t('description')}>
      <CloudInventoryAttachSection {...props} />
    </SettingsSection>
  );
}
